import { render } from "./SessionLiveHeader.vue?vue&type=template&id=078d3a10&scoped=true"
import script from "./SessionLiveHeader.vue?vue&type=script&lang=js"
export * from "./SessionLiveHeader.vue?vue&type=script&lang=js"

import "./SessionLiveHeader.vue?vue&type=style&index=0&id=078d3a10&scoped=true&lang=css"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078d3a10"]])

export default __exports__